<template>
  <div class="container">
    <Table mode="reapply" />
  </div>
</template>

<script>
import Table from "@/views/bidding/publicity/components/table";

export default {
  components: {
    Table,
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 48px 110px;
}
</style>
